import { Box, Divider, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function CardHeader({
  icon,
  title,
  description,
  action = null,
  showDivider = false,
  sx = {},
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box sx={{ mb: 2.2, ...sx }}>
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
          padding: 2,
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.4,
            minWidth: 0,
          }}
        >
          {icon && (
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 3,
                display: "grid",
                placeItems: "center",
                flexShrink: 0,

                background: isDark ? "rgba(25,118,210,0.12)" : "rgba(255,255,255,0.72)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                border: "1px solid rgba(47, 147, 247, 0.22)",
                boxShadow: "0 8px 22px rgba(0,0,0,0.08)",

                color: "primary.main",
                "& svg": {
                  fontSize: 28,
                  display: "block",
                },
              }}
            >
              {icon}
            </Box>
          )}

          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 950,
                lineHeight: 1.15,
                letterSpacing: 0.1,
              }}
            >
              {title}
            </Typography>

            {description ? (
              <Typography
                sx={{
                  fontSize: 13.5,
                  opacity: 0.72,
                  mt: 0.4,
                  lineHeight: 1.35,
                }}
              >
                {description}
              </Typography>
            ) : null}
          </Box>
        </Box>

        {action ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "flex-start", sm: "flex-end" },
              flexShrink: 0,
            }}
          >
            {action}
          </Box>
        ) : null}
      </Box>

      {showDivider && <Divider sx={{ mt: 2, opacity: 0.5 }} />}
    </Box>
  );
}
